import React, { useState } from 'react';
import { FaTrashAlt, FaPenSquare, FaMoneyBill, FaRegCalendarAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import useBills from '../hooks/useBills';
import {
  EditButton,
  DeleteButton,
  ViewPaymentsButton,
} from '../styles/ComponentStyles';
import {
  BillsTableWrapper,
  BillsTableEl,
  BillsTableHeader,
  BillsTableRow,
  BillsTableData,
  FrequencyBadge,
  StatusBadgeBills,
} from '../styles/BillsTableStyles';
import PaginationControl from './PaginationControl';
import PaymentsModal from './PaymentsModal';
import BillPayablesModal from './BillPayablesModal';
import { getPaymentStatus } from '../utils/billStatusHelper';


const BillsTable = ({
  refreshKey,
  setRefreshKey,
  handleFlashMessage,
  handleDelete,
  currentPage,
  currentPageLimit,
  onPageChange,
  onPageLimitChange,
  onViewPayments
}) => {
  const navigate = useNavigate();
  const { bills, totalPages, loading, error } = useBills(currentPage, currentPageLimit, refreshKey);

  const handleEdit = (billId) => navigate(`/edit-bill/${billId}`);

  const [selectedBill, setSelectedBill] = useState(null);
  // The bill whose due cycles (payables) are open — a separate modal from the
  // payments one, so opening either does not disturb the other.
  const [payablesBill, setPayablesBill] = useState(null);

  const handleCloseModal = () => {
    setSelectedBill(null);
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading bills.</div>;

  return (
    <BillsTableWrapper>
      <h2>Bills List</h2>
      <BillsTableEl>
        <thead>
          <tr>
            <BillsTableHeader>Biller</BillsTableHeader>
            <BillsTableHeader>Bill Type</BillsTableHeader>
            {/* <BillsTableHeader>Bill Payment Type</BillsTableHeader> */}
            <BillsTableHeader>Amount</BillsTableHeader>
            <BillsTableHeader>Due Date</BillsTableHeader>
            <BillsTableHeader>Status</BillsTableHeader>
            <BillsTableHeader>Frequency</BillsTableHeader>
            {/* <BillsTableHeader>Platform</BillsTableHeader> */}
            {/* <BillsTableHeader>Store</BillsTableHeader> */}
            <BillsTableHeader>Payments</BillsTableHeader>
            <BillsTableHeader>Remarks</BillsTableHeader>
            <BillsTableHeader>Actions</BillsTableHeader>
          </tr>
        </thead>
        <tbody>
          {bills.map((bill) => {
            const paymentStatus = getPaymentStatus(bill);
            const frequency = bill.payment_frequency || 'one_time';
            return (
              <BillsTableRow key={bill._id}>
                <BillsTableData>{bill.biller}</BillsTableData>
                <BillsTableData>{bill.bill_type}</BillsTableData>
                {/* <BillsTableData>{bill.bill_payment_type}</BillsTableData> */}
                <BillsTableData>{bill.amount}</BillsTableData>
                <BillsTableData>{bill.due_date}</BillsTableData>
                <BillsTableData>
                  <StatusBadgeBills $color={paymentStatus.color}>
                    {paymentStatus.label}
                  </StatusBadgeBills>
                </BillsTableData>
                <BillsTableData>
                  <FrequencyBadge $variant={frequency}>
                    {frequency === 'monthly' ? 'Monthly' : 'One-time'}
                  </FrequencyBadge>
                </BillsTableData>
                {/* <BillsTableData>{bill.platform}</BillsTableData> */}
                {/* <BillsTableData>{bill.store}</BillsTableData> */}
                <BillsTableData>{bill.count_of_payments}</BillsTableData>
                <BillsTableData>{bill.remarks}</BillsTableData>
                <BillsTableData>
                  <ViewPaymentsButton onClick={() => setSelectedBill(bill)} title="Payments">
                    <FaMoneyBill />
                  </ViewPaymentsButton>
                  <ViewPaymentsButton onClick={() => setPayablesBill(bill)} title="Payables (due cycles)">
                    <FaRegCalendarAlt />
                  </ViewPaymentsButton>
                  <EditButton onClick={() => handleEdit(bill._id)}>
                    <FaPenSquare />
                  </EditButton>
                  <DeleteButton onClick={() => handleDelete(bill._id)}>
                    <FaTrashAlt />
                  </DeleteButton>
                </BillsTableData>
              </BillsTableRow>
            );
          })}
        </tbody>
      </BillsTableEl>

      <PaginationControl
        currentPage={currentPage}
        currentPageLimit={currentPageLimit}
        totalPages={totalPages}
        handlePageChange={onPageChange}
        handlePageLimitChange={onPageLimitChange}
      />
      {selectedBill && (
        <PaymentsModal bill={selectedBill} onClose={handleCloseModal} />
      )}
      {payablesBill && (
        <BillPayablesModal
          bill={payablesBill}
          onClose={() => setPayablesBill(null)}
          onRefresh={() => setRefreshKey && setRefreshKey((prev) => prev + 1)}
        />
      )}
    </BillsTableWrapper>
  );
};

export default BillsTable;
